// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1_Ea0","buttons":"RemoveExpirationActionButtons_buttons__2dVGf"};